var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c(
      "div",
      { class: [_vm.useCncycd ? "form-multi-group--type2" : "form-row"] },
      [
        _vm.useCncycd
          ? _c(
              "div",
              [
                _c("select-box", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm._.isNil(_vm.cncycdList) ||
                        _vm.cncycdList.length > 1,
                      expression: "_.isNil(cncycdList) || cncycdList.length > 1"
                    }
                  ],
                  ref: "cncycd",
                  attrs: {
                    value: _vm.cncycdData,
                    "option-list": _vm.cncycdList
                  },
                  on: {
                    "update:value": function($event) {
                      _vm.cncycdData = $event
                    },
                    "update:optionList": function($event) {
                      _vm.cncycdList = $event
                    },
                    "update:option-list": function($event) {
                      _vm.cncycdList = $event
                    }
                  }
                }),
                !_vm._.isNil(_vm.cncycdList) && _vm.cncycdList.length == 1
                  ? _c("span", { staticClass: "unit" }, [
                      _vm._v(_vm._s(_vm.cncycdData))
                    ])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        !_vm.useCncycd && !_vm.isLoan
          ? _c("div", { staticClass: "item-tit" }, [
              _vm._v(_vm._s(/*입금 금액*/ _vm.$t("MPAY-01-01-08-04")))
            ])
          : _vm._e(),
        _vm.useCncycd
          ? [
              _c("div", [
                _c("div", { attrs: { required: "required" } }, [
                  _c("div", { staticClass: "form-text-field number" }, [
                    _c(
                      "div",
                      { staticClass: "input-text-field" },
                      [
                        !_vm.useCncycd
                          ? _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(_vm.cncycdData))
                            ])
                          : _vm._e(),
                        _c("input-text", {
                          ref: "amount",
                          attrs: {
                            id: "amount",
                            value: _vm.amountData,
                            placeholder: "0",
                            numericComma:
                              _vm.$config.SITECODE_OGMMR +
                              "|" +
                              _vm.$config.SITECODE_OGCBD +
                              "|" +
                              _vm.$config.SITECODE_OGIND +
                              "|" +
                              _vm.$config.SITECODE_OGAUC,
                            numeric: "" + _vm.$config.SITECODE_OGHCM,
                            required: "",
                            maxlength: 19,
                            "err-msg-param": {
                              filed: _vm.$t("MCOM-0000074"),
                              max: 19
                            },
                            "custom-error": _vm.customError,
                            "use-right-icon": false,
                            cncycd: _vm.cncycdData
                          },
                          on: {
                            "update:value": function($event) {
                              _vm.amountData = $event
                            },
                            "update:customError": function($event) {
                              _vm.customError = $event
                            },
                            "update:custom-error": function($event) {
                              _vm.customError = $event
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm.customError
                    ? _c(
                        "div",
                        { staticClass: "validate" },
                        [_vm._t("customErrorMsg")],
                        2
                      )
                    : _vm._e()
                ])
              ])
            ]
          : [
              _c("div", { staticClass: "item-desc" }, [
                _c("div", { staticClass: "form-text-field unit-number" }, [
                  _c(
                    "div",
                    { staticClass: "form-multi-group--type2" },
                    [
                      !_vm.useCncycd
                        ? _c("span", { staticClass: "unit" }, [
                            _vm._v(_vm._s(_vm.cncycdData))
                          ])
                        : _vm._e(),
                      _c("input-text", {
                        ref: "amount",
                        attrs: {
                          id: "amount",
                          value: _vm.amountData,
                          placeholder: "0",
                          numericComma:
                            _vm.$config.SITECODE_OGMMR +
                            "|" +
                            _vm.$config.SITECODE_OGCBD +
                            "|" +
                            _vm.$config.SITECODE_OGIND +
                            "|" +
                            _vm.$config.SITECODE_OGAUC,
                          numeric: "" + _vm.$config.SITECODE_OGHCM,
                          required: "",
                          maxlength: 19,
                          "err-msg-param": {
                            filed: _vm.$t("MCOM-0000074"),
                            max: 19,
                            maxValue: _vm.maxValue
                          },
                          "custom-error": _vm.customError,
                          "css-hide": false,
                          maxValue: _vm.maxValue,
                          "use-right-icon": false,
                          cncycd: _vm.cncycdData
                        },
                        on: {
                          "update:value": function($event) {
                            _vm.amountData = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "error",
                              fn: function() {
                                return [_vm._t("customErrorMsg")]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ])
              ])
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }